import factory from '../../../store/factory'

export default {
  transactions: factory('Transactions'),
  transactionNotes: factory('TransactionNotes'),
  templates: factory('Templates'),
  trades: factory('Trades'),
  quotes: factory('Quotes'),
  linkedAccount: factory('LinkedAccount'),
}